// GENERATED — do not edit
export const RPC_METHOD_TO_PATH: Record<string, string> = {
  "account_baseline.GetAccountBaselineStatus": "/account-baseline/rpc",
  "account_baseline.RunAccountBaseline": "/account-baseline/rpc",
  "account_baseline.SetAccountBaselineManaged": "/account-baseline/rpc",
  "account_baseline.SetAccountBreakGlass": "/account-baseline/rpc",
  "account_baseline.SetAccountOptionalBaseline": "/account-baseline/rpc",
  "account_baseline.TriggerReconciler": "/account-baseline/rpc",
  "admin.DeletePortalUser": "/customers/rpc",
  "admin.GetPolicy": "/customers/rpc",
  "admin.GetUser": "/customers/rpc",
  "admin.InvitePortalUser": "/customers/rpc",
  "admin.ListPolicies": "/customers/rpc",
  "admin.ListPortalUsers": "/customers/rpc",
  "admin.ListUsers": "/customers/rpc",
  "admin.ResendPortalInvite": "/customers/rpc",
  "admin.ResetPortalUserPassword": "/customers/rpc",
  "admin.SetPortalUserCloud2Admin": "/customers/rpc",
  "admin.UpdateUserGroups": "/customers/rpc",
  "agentspec.CreateAgent": "/prompts/rpc",
  "agentspec.GetAgentSpec": "/prompts/rpc",
  "agentspec.GetDefaultAgents": "/prompts/rpc",
  "agentspec.GetEffectiveLoadout": "/prompts/rpc",
  "agentspec.ListAgentSpecs": "/prompts/rpc",
  "agentspec.ListAvailableModels": "/prompts/rpc",
  "agentspec.ListInvocationShapes": "/prompts/rpc",
  "agentspec.ListRunnableAgents": "/prompts/rpc",
  "agentspec.RetireAgent": "/prompts/rpc",
  "agentspec.SetDefaultAgent": "/prompts/rpc",
  "agentspec.UpdateAgentSpec": "/prompts/rpc",
  "catalog.ActivateVersion": "/catalog/rpc",
  "catalog.CreatePipelineCredential": "/catalog/rpc",
  "catalog.CreatePortfolio": "/catalog/rpc",
  "catalog.CreateServiceComponent": "/catalog/rpc",
  "catalog.DeactivateVersion": "/catalog/rpc",
  "catalog.DeletePortfolio": "/catalog/rpc",
  "catalog.DeleteServiceComponent": "/catalog/rpc",
  "catalog.GetConvergenceStatus": "/catalog/rpc",
  "catalog.GetDependencyGraph": "/catalog/rpc",
  "catalog.GetPortfolio": "/catalog/rpc",
  "catalog.GetPortfolioServiceComponents": "/catalog/rpc",
  "catalog.GetServiceComponent": "/catalog/rpc",
  "catalog.GetServiceComponentSources": "/catalog/rpc",
  "catalog.GetServiceComponentsForService": "/catalog/rpc",
  "catalog.GetSharingStatus": "/catalog/rpc",
  "catalog.ListPipelineCredentials": "/catalog/rpc",
  "catalog.ListPortfolios": "/catalog/rpc",
  "catalog.ListServiceComponents": "/catalog/rpc",
  "catalog.ListServices": "/catalog/rpc",
  "catalog.ListVersions": "/catalog/rpc",
  "catalog.PreviewSubscribe": "/catalog/rpc",
  "catalog.RevokePipelineCredential": "/catalog/rpc",
  "catalog.SetCurrentVersion": "/catalog/rpc",
  "catalog.TriggerReconciler": "/catalog/rpc",
  "catalog.UpdatePortfolio": "/catalog/rpc",
  "catalog.UpdateServiceComponent": "/catalog/rpc",
  "customers.ApproveEscalation": "/customers/rpc",
  "customers.CreateAWSAccount": "/customers/rpc",
  "customers.CreateCustomer": "/customers/rpc",
  "customers.DeleteAWSAccount": "/customers/rpc",
  "customers.DeleteCustomer": "/customers/rpc",
  "customers.GetCliCredentials": "/customers/rpc",
  "customers.GetConsoleAccess": "/customers/rpc",
  "customers.GetCustomer": "/customers/rpc",
  "customers.GetEscalationChain": "/customers/rpc",
  "customers.ListAWSAccounts": "/customers/rpc",
  "customers.ListContacts": "/customers/rpc",
  "customers.ListCustomers": "/customers/rpc",
  "customers.ListEscalations": "/customers/rpc",
  "customers.ListFreshserviceAgents": "/customers/rpc",
  "customers.ListFreshserviceCompanies": "/customers/rpc",
  "customers.ListFreshserviceGroups": "/customers/rpc",
  "customers.ListFreshserviceStatuses": "/customers/rpc",
  "customers.ListPendingApprovals": "/customers/rpc",
  "customers.Me": "/customers/rpc",
  "customers.MePermissions": "/customers/rpc",
  "customers.MyAccess": "/customers/rpc",
  "customers.ReorderOperationalContacts": "/customers/rpc",
  "customers.RequestEscalation": "/customers/rpc",
  "customers.RevokeEscalation": "/customers/rpc",
  "customers.SetAWSAccountAdminRoles": "/customers/rpc",
  "customers.TestItsmConfig": "/customers/rpc",
  "customers.UpdateAWSAccount": "/customers/rpc",
  "customers.UpdateContactMetadata": "/customers/rpc",
  "customers.UpdateCustomer": "/customers/rpc",
  "customers.UpdateCustomerContactTypes": "/customers/rpc",
  "customers.UpdateEscalationChain": "/customers/rpc",
  "customers.UpdateItsmConfig": "/customers/rpc",
  "customers.UpdatePortalUser": "/customers/rpc",
  "customers.ValidateOpsRoleAccess": "/customers/rpc",
  "customers.ValidateRoleAccess": "/customers/rpc",
  "deployments.AcceptActualState": "/catalog/rpc",
  "deployments.ApproveDeployment": "/catalog/rpc",
  "deployments.BulkAcknowledge": "/catalog/rpc",
  "deployments.BulkTerminate": "/catalog/rpc",
  "deployments.BulkUpdate": "/catalog/rpc",
  "deployments.DeleteDeployment": "/catalog/rpc",
  "deployments.GetDeployment": "/catalog/rpc",
  "deployments.GetDriftSummary": "/catalog/rpc",
  "deployments.GetHistory": "/catalog/rpc",
  "deployments.GetStackStatus": "/catalog/rpc",
  "deployments.ListDeployments": "/catalog/rpc",
  "deployments.ListStackStatus": "/catalog/rpc",
  "deployments.RequestHeartbeat": "/catalog/rpc",
  "deployments.ResolveRescue": "/catalog/rpc",
  "deployments.SetDesiredParameters": "/catalog/rpc",
  "deployments.SetDesiredState": "/catalog/rpc",
  "deployments.Subscribe": "/catalog/rpc",
  "deployments.Unsubscribe": "/catalog/rpc",
  "evalcase.AuthorEvalCase": "/prompts/rpc",
  "evalcase.GetEvalCase": "/prompts/rpc",
  "evalcase.ListEvalCases": "/prompts/rpc",
  "events.CloseActionLogItem": "/events/rpc",
  "events.CreateCustomerEventDatasetTemplate": "/events/rpc",
  "events.CreateCustomerTemplate": "/events/rpc",
  "events.CreateEventDataset": "/events/rpc",
  "events.CreateGlobalEventDatasetTemplate": "/events/rpc",
  "events.CreateGlobalTemplate": "/events/rpc",
  "events.CreateRule": "/events/rpc",
  "events.DeleteActionLogItem": "/events/rpc",
  "events.DeleteEventDataset": "/events/rpc",
  "events.DeleteEventDatasetTemplate": "/events/rpc",
  "events.DeleteGlobalEventDatasetTemplate": "/events/rpc",
  "events.DeleteGlobalTemplate": "/events/rpc",
  "events.DeleteRule": "/events/rpc",
  "events.DeleteTemplate": "/events/rpc",
  "events.GetActionLog": "/events/rpc",
  "events.GetActionLogItem": "/events/rpc",
  "events.GetEventDataset": "/events/rpc",
  "events.GetEventDatasetRetentionCeiling": "/events/rpc",
  "events.GetEventDatasetStatus": "/events/rpc",
  "events.GetEventDatasetTemplate": "/events/rpc",
  "events.GetEventTrace": "/events/rpc",
  "events.GetEvents": "/events/rpc",
  "events.GetReport": "/events/rpc",
  "events.GetReportPdf": "/events/rpc",
  "events.GetRule": "/events/rpc",
  "events.GetRuleSampleEvent": "/events/rpc",
  "events.GetTemplate": "/events/rpc",
  "events.ListCustomerEventDatasetTemplates": "/events/rpc",
  "events.ListCustomerTemplates": "/events/rpc",
  "events.ListEventDatasetMisfits": "/events/rpc",
  "events.ListEventDatasets": "/events/rpc",
  "events.ListGlobalEventDatasetTemplates": "/events/rpc",
  "events.ListGlobalTemplates": "/events/rpc",
  "events.ListRules": "/events/rpc",
  "events.ListRulesNamingAgent": "/events/rpc",
  "events.PreviewEventDataset": "/events/rpc",
  "events.PreviewRuleOutput": "/events/rpc",
  "events.QueryEventDataset": "/events/rpc",
  "events.RebuildEventDataset": "/events/rpc",
  "events.RetryReport": "/events/rpc",
  "events.SuggestFieldMappings": "/events/rpc",
  "events.TestPattern": "/events/rpc",
  "events.TestTransform": "/events/rpc",
  "events.TriggerReconciler": "/events/rpc",
  "events.TriggerRuleNow": "/events/rpc",
  "events.UpdateEventDataset": "/events/rpc",
  "events.UpdateEventDatasetTemplate": "/events/rpc",
  "events.UpdateGlobalEventDatasetTemplate": "/events/rpc",
  "events.UpdateGlobalTemplate": "/events/rpc",
  "events.UpdateRule": "/events/rpc",
  "events.UpdateTemplate": "/events/rpc",
  "game.ClaimTask": "/game/rpc",
  "game.CompleteTask": "/game/rpc",
  "game.ConfigureQuest": "/game/rpc",
  "game.GetAchievements": "/game/rpc",
  "game.GetCustomerHealth": "/game/rpc",
  "game.GetFortressMap": "/game/rpc",
  "game.GetLeaderboard": "/game/rpc",
  "game.GetMorningBriefing": "/game/rpc",
  "game.GetPlayerProfile": "/game/rpc",
  "game.GetQuest": "/game/rpc",
  "game.GetStatus": "/game/rpc",
  "game.ListQuestTasks": "/game/rpc",
  "game.ListQuests": "/game/rpc",
  "game.UpdateTaskQuality": "/game/rpc",
  "investigations.AbandonWorkflowRun": "/investigations/rpc",
  "investigations.AddFinding": "/investigations/rpc",
  "investigations.CheckWorkflowAccess": "/investigations/rpc",
  "investigations.ClearConversation": "/investigations/rpc",
  "investigations.CompleteStep": "/investigations/rpc",
  "investigations.CreateInvestigation": "/investigations/rpc",
  "investigations.DeleteFindings": "/investigations/rpc",
  "investigations.DeleteInvestigation": "/investigations/rpc",
  "investigations.DeleteKnowledgeItems": "/investigations/rpc",
  "investigations.ExecutePlaybook": "/investigations/rpc",
  "investigations.GetConversation": "/investigations/rpc",
  "investigations.GetCurrentStep": "/investigations/rpc",
  "investigations.GetFindings": "/investigations/rpc",
  "investigations.GetInvestigation": "/investigations/rpc",
  "investigations.GetKnowledgeItems": "/investigations/rpc",
  "investigations.GetWorkflowRun": "/investigations/rpc",
  "investigations.LinkWorkflowRun": "/investigations/rpc",
  "investigations.ListCustomerWorkflowRuns": "/investigations/rpc",
  "investigations.ListInvestigations": "/investigations/rpc",
  "investigations.ListRunnableWorkflows": "/investigations/rpc",
  "investigations.ListWorkflowRuns": "/investigations/rpc",
  "investigations.ReportStepFailed": "/investigations/rpc",
  "investigations.RequestWorkflowGate": "/investigations/rpc",
  "investigations.ResolveWorkflowGate": "/investigations/rpc",
  "investigations.RetryWorkflowStep": "/investigations/rpc",
  "investigations.SetInvestigationPlaybook": "/investigations/rpc",
  "investigations.StartWorkflow": "/investigations/rpc",
  "investigations.TakeBranch": "/investigations/rpc",
  "investigations.UpdateFinding": "/investigations/rpc",
  "investigations.UpdateFindingRanks": "/investigations/rpc",
  "investigations.UpdateInvestigation": "/investigations/rpc",
  "investigations.UpdateKnowledgeItemRanks": "/investigations/rpc",
  "itsm.AddTicketNote": "/itsm/rpc",
  "itsm.GetTicket": "/itsm/rpc",
  "itsm.ListTickets": "/itsm/rpc",
  "knowledge.CustomerDeleteDocument": "/knowledge/rpc",
  "knowledge.CustomerGetDocumentContent": "/knowledge/rpc",
  "knowledge.CustomerGetDownloadUrl": "/knowledge/rpc",
  "knowledge.CustomerGetKnowledgeBase": "/knowledge/rpc",
  "knowledge.CustomerGetSyncStatus": "/knowledge/rpc",
  "knowledge.CustomerListDocuments": "/knowledge/rpc",
  "knowledge.CustomerQueryKnowledgeBase": "/knowledge/rpc",
  "knowledge.CustomerStartSync": "/knowledge/rpc",
  "knowledge.CustomerUploadDocument": "/knowledge/rpc",
  "knowledge.DeleteDocument": "/knowledge/rpc",
  "knowledge.GetDocumentContent": "/knowledge/rpc",
  "knowledge.GetKnowledgeBase": "/knowledge/rpc",
  "knowledge.ListDocuments": "/knowledge/rpc",
  "knowledge.ListKnowledgeBases": "/knowledge/rpc",
  "knowledge.StartSync": "/knowledge/rpc",
  "modelbinding.ListModelBindings": "/prompts/rpc",
  "modelbinding.UpdateModelBinding": "/prompts/rpc",
  "operations.GetActivityLog": "/catalog/rpc",
  "operations.GetDeploymentMap": "/catalog/rpc",
  "operations.GetDriftDashboard": "/catalog/rpc",
  "ops.GetControlPlaneHealth": "/ops/rpc",
  "ops.GetCustomerControlPlane": "/ops/rpc",
  "ops.GetExecutionDetail": "/ops/rpc",
  "ops.GetFeatureSwitches": "/ops/rpc",
  "ops.GetReconcilerHealth": "/ops/rpc",
  "ops.GetReconcilerStatus": "/ops/rpc",
  "ops.GetResult": "/ops/rpc",
  "ops.GetState": "/ops/rpc",
  "ops.ListExecutions": "/ops/rpc",
  "ops.ListReconcilerResources": "/ops/rpc",
  "ops.ListReconcilers": "/ops/rpc",
  "ops.PauseReconciler": "/ops/rpc",
  "ops.ResumeReconciler": "/ops/rpc",
  "ops.SetFeatureSwitch": "/ops/rpc",
  "ops.Start": "/ops/rpc",
  "prompts.CreateCustomerPrompt": "/prompts/rpc",
  "prompts.CreateGlobalPrompt": "/prompts/rpc",
  "prompts.DeleteCustomerPrompt": "/prompts/rpc",
  "prompts.DeleteCustomerPromptVersion": "/prompts/rpc",
  "prompts.DeleteGlobalPrompt": "/prompts/rpc",
  "prompts.DeleteGlobalPromptVersion": "/prompts/rpc",
  "prompts.GetCustomerPrompt": "/prompts/rpc",
  "prompts.GetCustomerPromptVersion": "/prompts/rpc",
  "prompts.GetGlobalPrompt": "/prompts/rpc",
  "prompts.GetGlobalPromptVersion": "/prompts/rpc",
  "prompts.ListCustomerPrompts": "/prompts/rpc",
  "prompts.ListGlobalPrompts": "/prompts/rpc",
  "prompts.PublishCustomerPrompt": "/prompts/rpc",
  "prompts.PublishGlobalPrompt": "/prompts/rpc",
  "prompts.TestPrompt": "/prompts/rpc",
  "prompts.UpdateCustomerPrompt": "/prompts/rpc",
  "prompts.UpdateGlobalPrompt": "/prompts/rpc",
  "rpc.discover": "/ops/rpc",
  "service_components.GetVersionParameters": "/catalog/rpc",
  "service_components.ListResolvers": "/catalog/rpc",
  "service_components.RegisterArtifact": "/catalog/rpc",
  "service_components.RequestTemplateUpload": "/catalog/rpc",
  "service_components.SetVersionBindings": "/catalog/rpc",
  "service_offerings.AddCapability": "/catalog/rpc",
  "service_offerings.CreateServiceOffering": "/catalog/rpc",
  "service_offerings.CreateSubscription": "/catalog/rpc",
  "service_offerings.DeleteServiceOffering": "/catalog/rpc",
  "service_offerings.DeprecateServiceOffering": "/catalog/rpc",
  "service_offerings.EditCapabilityConfigOverride": "/catalog/rpc",
  "service_offerings.EditCapabilityOverride": "/catalog/rpc",
  "service_offerings.GetOfferingReadiness": "/catalog/rpc",
  "service_offerings.GetServiceOffering": "/catalog/rpc",
  "service_offerings.GetSubscribedOffering": "/catalog/rpc",
  "service_offerings.Health": "/catalog/rpc",
  "service_offerings.ListServiceOfferings": "/catalog/rpc",
  "service_offerings.ListSubscribedOfferings": "/catalog/rpc",
  "service_offerings.PreviewResolution": "/catalog/rpc",
  "service_offerings.PublishServiceOffering": "/catalog/rpc",
  "service_offerings.RemoveCapability": "/catalog/rpc",
  "service_offerings.RemoveCapabilityConfigOverride": "/catalog/rpc",
  "service_offerings.RevokeSubscription": "/catalog/rpc",
  "service_offerings.SetOperatorInputs": "/catalog/rpc",
  "service_offerings.ToggleCapability": "/catalog/rpc",
  "service_offerings.UpdateServiceOffering": "/catalog/rpc",
  "toolset.ListToolConfigs": "/prompts/rpc",
  "toolset.UpsertToolConfig": "/prompts/rpc",
  "trial.GetTrial": "/prompts/rpc",
  "trial.GradeTrial": "/prompts/rpc",
  "trial.ListTrials": "/prompts/rpc",
  "trial.StartTrial": "/prompts/rpc",
  "workflow.CreateWorkflow": "/prompts/rpc",
  "workflow.DeleteWorkflow": "/prompts/rpc",
  "workflow.GetWorkflow": "/prompts/rpc",
  "workflow.ListWorkflows": "/prompts/rpc",
  "workflow.PublishWorkflow": "/prompts/rpc",
  "workflow.UpdateWorkflowDraft": "/prompts/rpc",
};
